export enum UserRole {
  SUPER_ADMIN = 'Super Admin',
  PLATFORM_ADMIN = 'Platform Admin',
  REVIEWER = 'Reviewer',
  TAXI_NETWORK_ADMIN = 'Taxi Network Admin',
  TAXI_NETWORK = 'Taxi Network',
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  organizationId: string;
  organizationName: string;
  isActive: boolean;
  permissions: string[];
}

export interface Organization {
  id: string;
  name: string;
  abn: string;
  contactPerson: string;
  email: string;
  phone: string;
  isActive: boolean;
  termsAgreedOn: string | null;
}

export enum EntityType {
  DRIVER = 'Driver',
  OPERATOR = 'Operator',
  TAXI = 'Taxi',
}

export interface Driver {
  id: string;
  name: string;
  licenceNumber: string;
  dateOfBirth: string;
  contact: string;
}

export interface Operator {
  id: string;
  name: string;
  abn: string;
  contact: string;
}

export interface Taxi {
  id: string;
  plateNumber: string;
  vin: string;
  make: string;
  model: string;
  year: number;
  // FIX: Add name property to Taxi to align with other entity types and resolve type errors.
  name: string;
}

export type Entity = Driver | Operator | Taxi;

export enum IncidentType {
  UNPAID_FEES_DEBT = 'Unpaid Fees / Debt',
  SAFETY_BREACH = 'Safety Breach',
  UNSAFE_DRIVING = 'Unsafe Driving',
  BEHAVIOUR_MISCONDUCT = 'Behaviour Misconduct',
  REGULATORY_BREACH = 'Regulatory Breach',
  LICENCE_AUTHORITY_ISSUE = 'Licence / Authority Issue',
  EQUIPMENT_TAMPERING = 'Equipment Tampering (Meter / GPS / Camera)',
  VEHICLE_ACCIDENT = 'Vehicle Accident',
  VEHICLE_DAMAGE = 'Vehicle Damage',
  FRAUDULENT_ACTIVITY = 'Fraudulent Activity',
  CRIMINAL_MISCONDUCT = 'Criminal Misconduct',
  POLICY_VIOLATION = 'Policy Violation',
  GENERAL_INCIDENT = 'General Incident',
  OTHER = 'Other (Specify)',
}


export enum Severity {
  MINOR = 'Minor',
  MAJOR = 'Major',
  CRITICAL = 'Critical',
}

export enum IncidentStatus {
  OPEN = 'Open',
  UNDER_REVIEW = 'Under Review',
  DISPUTED = 'Disputed',
  RESOLVED = 'Resolved',
}

export interface Incident {
  id: string;
  entityId: string;
  entityType: EntityType;
  entityDetails: Entity;
  incidentType: IncidentType;
  severity: Severity;
  description: string;
  debtAmount?: number;
  reportedDate: string;
  incidentDate: string;
  resolvedDate?: string;
  status: IncidentStatus;
  reporterOrgId: string;
  reporterOrgName: string;
  attachments: { name: string; url: string }[];
  history: { status: IncidentStatus; updated: string; notes: string }[];
  dispute?: { disputedDate: string; reason: string; isValid?: boolean };
  resolution?: { resolvedDate: string; notes: string };
}

export interface ActivityLog {
  id: string;
  userId: string;
  userName: string;
  action: string;
  details: string;
  timestamp: string;
}

export interface LegalContent {
  privacyPolicy: string;
  termsAndConditions: string;
}

export interface PlatformSettings {
    platformName: string;
    platformLogo: string;
    loginPageTitle: string;
    loginPageLogo: string;
    footerText: string;
    // Notification Settings
    adminEmail: string;
    notifyOnNewIncident: boolean;
    notifyOnStatusChange: boolean;
    notifyOnNewRegistration: boolean;
    // SMTP Settings
    smtpHost: string;
    smtpPort: number;
    smtpUsername: string;
    smtpPassword?: string;
    smtpEncryption: 'none' | 'ssl' | 'tls';
    smtpFromAddress: string;
    smtpFromName: string;
    // Legal Content
    legalContent: LegalContent;
}